import { render, staticRenderFns } from "./StoreOrderComponent.vue?vue&type=template&id=15828fd8&scoped=true"
import script from "./StoreOrderComponent.vue?vue&type=script&lang=js"
export * from "./StoreOrderComponent.vue?vue&type=script&lang=js"
import style0 from "./StoreOrderComponent.vue?vue&type=style&index=0&id=15828fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15828fd8",
  null
  
)

export default component.exports